export const SEND_PHONE = 'AUTH_STEP__SEND_PHONE';
export const SEND_CODE = 'AUTH_STEP__SEND_CODE';
export const SIGN_UP_SEND_PHONE = 'AUTH_STEP__SIGN_UP_SEND_PHONE';
export const SIGN_UP_SEND_CODE = 'AUTH_STEP__SIGN_UP_SEND_CODE';
